import Cookies from 'js-cookie';
import store from 'redux/store';
import { isVoc } from 'utils/killswitch';

declare const QSI: any;

const PREFIX_ = 'qsi_';
const COOKIES_EXPIRE = 1;

export const removePrefixedCookies = () => {
	const allCookies = Object.keys(Cookies.get());
	Object.keys(allCookies).forEach((key) => {
		if (key.startsWith(PREFIX_)) {
			Cookies.remove(key);
		}
	});
};

export const setQualtricsEmbeddedData = (data: any) => {
	const state = store.getState();
	const _data = {
		nmfloid: state.session.user.nmfloId ?? 'N/A',
		language: state.settings.language,
		location: '',
		billing_type: '',
		city: '',
		country: '',
		account: state.session.user.userName,
		org_name: state.session.user.accountName,
		user_type: state.session.user.userType,
		cr_number: state.session.user.upId,
		activity_type: '',
		service_fixed: '',
		service_internet: '',
		...data,
	};

	Object.entries(_data).forEach((key) => {
		Cookies.set(PREFIX_ + key[0], key[1] as string, { expires: COOKIES_EXPIRE });
	});
};

export const loadQualtrics = (data?: any) => {
	const state = store.getState();
	const isVocOn = isVoc(state.settings.remoteConfig); // kill switch for voc
	if (isVocOn && 'QSI' in window && state.session.user.nmfloId) {
		if (data) setQualtricsEmbeddedData(data);
		QSI.API.unload();
		QSI.API.load();
		QSI.API.run();
	}
};

export const unLoadQualtrics = () => {
	// removed all existing cookies which start with ${PREFIX_} for QSI and unload the QSI
	removePrefixedCookies();
	if ('QSI' in window && QSI?.API) {
		QSI.API.unload();
	}
};
